function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "76px",
    height: "76px",
    viewBox: "0 0 76 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(46.666667%,48.235294%,70.196078%)",
      fillOpacity: 1
    },
    d: "M 11.398438 0 L 64.601562 0 C 70.894531 0 76 5.105469 76 11.398438 L 76 64.601562 C 76 70.894531 70.894531 76 64.601562 76 L 11.398438 76 C 5.105469 76 0 70.894531 0 64.601562 L 0 11.398438 C 0 5.105469 5.105469 0 11.398438 0 Z M 11.398438 0 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1,
      strokeWidth: 6,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 155 202 L 97 202 C 95.657895 201.921053 94.447368 202.736842 94 204 L 67 345 C 67 348 70 348 70 348 L 100 348 C 103 348 103 346 103 346 L 110 311 L 137 311 C 179 311 200 283 205 258 C 210 233 206 202 155 202 Z M 168 256 C 164 275 151 283 133 283 L 115 283 L 126 230 L 144 230 C 171 230 170 240 168 256 Z M 168 256 ",
    transform: "matrix(0.148438,0,0,0.148438,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1,
      strokeWidth: 6,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 275 311 C 271 311 272 307 272 307 L 284 246 C 284 238 290 230 266 231 L 248 231 L 233 309 C 233 309 233 312 229 312 L 200 312 C 197 312 197 309 197 309 L 225 168 C 225 168 225 166 229 166 L 259 166 C 262 166 261 169 261 169 L 254 203 L 280 203 C 316 203 325 220 322 240 L 309 309 C 309 309 309 312 304 312 Z M 275 311 ",
    transform: "matrix(0.148438,0,0,0.148438,0,0)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1,
      strokeWidth: 6,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(100%,100%,100%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 155 202 L 97 202 C 95.657895 201.921053 94.447368 202.736842 94 204 L 67 345 C 67 348 70 348 70 348 L 100 348 C 103 348 103 346 103 346 L 110 311 L 137 311 C 179 311 200 283 205 258 C 210 233 206 202 155 202 Z M 168 256 C 164 275 151 283 133 283 L 115 283 L 126 230 L 144 230 C 171 230 170 240 168 256 Z M 168 256 ",
    transform: "matrix(0.148438,0,0,0.148438,35.476562,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhp);
export default __webpack_public_path__ + "static/media/php.58bb984a5919b0e89eaffe9f2f7ced5f.svg";
export { ForwardRef as ReactComponent };